import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Input,
  Icon,
  Avatar,
  Divider,
  Popconfirm
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import SellerForm from './components/SellerForm'
import axios from 'axios'
import Highlighter from 'react-highlight-words'

const Seller = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [seller, setSeller] = useState([])
  const [searchText, setSearchText] = useState('')
  let searchInput = useRef(null)

  async function fetchSeller() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/seller/all`
      )
      setSeller(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function updateSeller(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/updateSeller`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function createSeller(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/createSeller`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function deleteSeller(id) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.delete(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/seller/` + id, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchSeller()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await fetchSeller()
    await setVisible(false)
  }

  const refetchData = async () => { }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await updateSeller(data)
    } else {
      await createSeller(data)
    }
    await fetchSeller()
    await setVisible(false)
    await setFormData({})
  }

  const onSubDelete = async (id) => {
    await deleteSeller(id)
    await fetchSeller()
  }

  const columns = [
    {
      title: 'ชื่อผู้ขาย',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={record.logo} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{text}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'detail',
      key: 'detail',
      ...getColumnSearchProps('detail'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'เบอร์โทรศัทพ์',
      dataIndex: 'tel',
      key: 'tel',
      ...getColumnSearchProps('tel'),
    },
    {
      title: 'Line Id',
      dataIndex: 'lineId',
      key: 'lineId',
      ...getColumnSearchProps('lineId'),
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onSubDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Seller"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Seller
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }
    >
      <Table
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={seller}
        columns={columns}
      />
      <SellerForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Seller)


// WEBPACK FOOTER //
// ./src/pages/Seller/index.js